/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item = {
    readonly serviceId: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
    readonly defaultSkuId: string | null;
    readonly itemType: string | null;
    readonly seller?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_seller">;
    } | null;
    readonly internalBuyLinks?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_links">;
    } | null> | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly skuLeadTime: string | null;
        readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_sku" | "PdpRespSidebarBlurbs_sku">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingModule_item" | "PdpRespExitModal_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespBreadcrumbs_item" | "PdpRespHeroCarouselPrint_item" | "PdpRespTitle_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarBlurbs_item" | "PdpRespShippingReturns_item" | "PdpRespSidebarContact_item" | "PdpRespSimilarItemsFooter_item" | "PdpSharedQuantitySelect_item" | "PdpSharedRecentHistoryTracker_item" | "SharedRespLinksBlock_item" | "PriceDisplay_item" | "PdpRespSwatchSelector_item" | "PdpSharedShippingBadge_item" | "PdpSharedFrameIncluded_item" | "PdpRespDealerDetails_item" | "PdpRespAboutModule_item" | "PdpRespHeroCarousel_item" | "PdpSharedDescriptionAboutCreator_item" | "PdpSharedDescriptionAboutMaker_item">;
    readonly " $refType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$data = PdpRespContainer_item;
export type PdpRespContainer_item$key = {
    readonly " $data"?: PdpRespContainer_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "hasUserId",
  "variableName": "fetchUser"
},
v2 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v3 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "PdpRespContainer_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isStoryTellingModuleVariant",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultSkuId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "itemType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "skus",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "skuLeadTime",
          "name": "leadTime",
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "PDP"
            }
          ],
          "storageKey": "leadTime(pageType:\"PDP\")"
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMultiSku",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku",
              "args": [
                {
                  "kind": "Literal",
                  "name": "hasSkuId",
                  "value": true
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarBlurbs_sku",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isStoryTellingModuleVariant",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespStorytellingModule_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespExitModal_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselPrint_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTracker_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item",
      "args": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedFrameIncluded_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfo_seller",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "internalBuyLinks",
          "storageKey": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_item",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isStoryTellingModuleVariant",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDescriptionAboutCreator_item",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDescriptionAboutMaker_item",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '2c20d4b7711132788b0bd584c569ec74';
export default node;
